// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import Modal from '../utils/ModalComponet';

const StyledTable = styled(Table)`
  &&& {
    margin-bottom: 20px;
  }
`;

const LimitedCell = styled.td`
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FareharborCompaniesModal = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  closeModal,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onCancel,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  companies,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onAssociate,
}) => {
  return (
    <Modal
      open
      closeModal={closeModal}
      cancel={onCancel}
      action={onAssociate}
      actionButtonText='Associate'
      stylesProps={{
        maxWidth: '1000px',
        width: '1000px',
        overflow: 'auto',
      }}
    >
      <h3>Select a company to associate with</h3>
      <StyledTable>
        <thead>
          <tr>
            <th>Name</th>
            <th>Short Name</th>
            <th>Url</th>
            <th>Stripe Connected Account</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {companies.map(item => (
            <tr key={item.shortname}>
              <td>{item.name}</td>
              <td>{item.shortname}</td>
              <td>{item.url}</td>
              <LimitedCell>{item.stripe_connect_account}</LimitedCell>
              <td>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => onAssociate(item.shortname)}
                >
                  Select
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </Modal>
  );
};

export default FareharborCompaniesModal;
